import gql from "graphql-tag";

const getProyect = gql`
  query Query($args: FilterParamsInput) {
    searchProjects(args: $args) {
      data {
        id
        name
        description
        responsible {
          id
          name
          first_surname
          second_surname
          position
          email
          isValidator
          area {
            id
            name
            description
            isActive
          }
        }
        code
        weighing
        createdAt
        updatedAt
        deletedAt
        objectives {
          id
          weighing
        }
        activities {
          id
          code
          name
          initial_date
          end_date
          completed
          historic {
            id
            period
            planned
            executed
          }
          responsible {
            name
            id
            position
            email
          }
          additions {
            id
            name
            file
            amount
            note
            comment
            type
            comments {
              id
              comment
              createdAt
            }
            files {
              id
              name
              description
              path
              createdAt
            }
          }
        }
        weightingHistory {
          id
          createdAt
          updatedAt
          deletedAt
          period
          weighing
        }
        strategies {
          id
          name
          description
        }
      }
    }
  }
`;

export { getProyect }